import iconIndex from "@/views/recognize/icon/iconIndex.vue";
export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: "iconIndex",
      name: "iconIndex",
      component: iconIndex,
    },

  ],
};
